import type { TagPath } from "@/types/dataPointTypes.ts"

export const getTagFolder = (path: TagPath): TagPath => {
  let newPath: TagPath = {
    ...path,
    tag: undefined,
  }

  if (path.tag != undefined) {
    const pathArray = path.tag.split("/")
    if (pathArray.length > 1) {
      pathArray.pop()
      newPath.tag = pathArray.join("/")
    }
  } else if (path.driver != undefined) {
    newPath.driver = undefined
  } else {
    newPath = {}
  }

  return newPath
}
